import Stack from '@mui/material/Stack';
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import FormHelperText from '@mui/material/FormHelperText';
import MenuItem from '@mui/material/MenuItem';
import SelectMui from '@mui/material/Select';
import PropTypes from 'prop-types';
import TextFieldMui from '@mui/material/TextField';

const Select = (props) => {
	const { label, error, helperText, options = [], value, ...rest } = props;

	const inputNode = (
		<TextFieldMui select value={value || ''} {...rest}>
			{options.map(({ label, value: val }) => {
				return (
					<MenuItem key={val} value={val}>
						{label}
					</MenuItem>
				);
			})}
		</TextFieldMui>
	);

	return (
		<Stack spacing={1}>
			{label && <InputLabel error={!!error}>{label}</InputLabel>}
			<FormControl>
				{inputNode}
				{helperText && <FormHelperText>{helperText}</FormHelperText>}
				{error && <FormHelperText error>{error}</FormHelperText>}
			</FormControl>
		</Stack>
	);
};

Select.propTypes = {
	...SelectMui.propTypes, // https://mui.com/material-ui/api/select/#props
	label: PropTypes.string,
	error: PropTypes.string,
	helperText: PropTypes.string,
	options: PropTypes.arrayOf(
		PropTypes.shape({
			label: PropTypes.string,
			value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
		}),
	),
};

export default Select;
